var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Tool.Setting"),
        width: "650px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.activeTabName,
            callback: function($$v) {
              _vm.activeTabName = $$v
            },
            expression: "activeTabName"
          }
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                lazy: true,
                label: _vm.$t("SystemMaintenance.ApplicationSettings"),
                name: "applicationSettings"
              }
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: {
                    disabled: !_vm.isEdit,
                    "label-width": "120px",
                    "label-position": "right"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "title",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SystemMaintenance.DropdownBoxValueDisplay"
                              )
                            )
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { "margin-top": "5px" },
                          model: {
                            value: _vm.form.recentlyUsedDropdownData,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.form,
                                "recentlyUsedDropdownData",
                                $$v
                              )
                            },
                            expression: "form.recentlyUsedDropdownData"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SystemMaintenance.DisplayRecentlyUsed50Values"
                              )
                            )
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("SystemMaintenance.DisplayOrderLogic"))
                      )
                    ]),
                    _c(
                      "span",
                      {
                        staticStyle: { "line-height": "28px", color: "black" }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "SystemMaintenance.TheFirstValueTheSequentially"
                            )
                          )
                        )
                      ]
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.okHandler } },
            [_vm._v(_vm._s(_vm.$t("Message.Confirm")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }